import { styled } from '@mui/material'

export const TextFieldLabel = styled('span')<{ required?: boolean }>(({ required, theme }) => ({
  '&::before': {
    content: required ? "'*'" : undefined,
    color: theme.palette.error[500],
  },
}))
